export const zh = {
    "en": "English",
    "zh": "中文",
    "Language": "语言",
    "Text": "文本",
    "RequiredFormat": "请输入 {0}",
    "I18nRequiredFormat": "请输入 {0} {1}"
}